import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'classe'
})
export class ClassePipe implements PipeTransform {
tabTemp = [];
  transform(tabClasse: any, selected: any, selected2: any, selected3: any, selected4: any): any {
    this.tabTemp = tabClasse;
    if (selected) {
      // if (selected.libelle !== null) {
        tabClasse = tabClasse.filter((a) => JSON.stringify(a.cycle) == JSON.stringify(selected));
     // }
    }
    if (selected2) {
     // if (selected2.libelle !== null) {
        tabClasse = tabClasse.filter((a) => a.niveau.libelle == selected2.libelle);
     // }
    }

    if (selected3) {
      tabClasse = tabClasse.filter((a) => a.serie.libelle == selected3.libelle);
    }

    if (selected4) {
      // if (selected4.libelle !== null) {
        tabClasse = tabClasse.filter((a) => a.libelle == selected4.libelle);
      //}
    }

    return tabClasse;
    }

}
